export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
